import { z } from 'zod';

export const stockIssueCategoryFormSchema = z.object({
  code: z.string().trim().min(1, '代號不能為空').max(50, '代號最多 50 字'),
  name: z.string().trim().min(1, '名稱不能為空').max(100, '名稱最多 100 字'),
  remark: z.string().max(500, '備註最多 500 字').optional().or(z.literal('')),
});

export const STOCK_ISSUE_CATEGORY_FIELD_LABELS = {
  code: '代號',
  name: '名稱',
  remark: '備註',
};
